import { makeZeroArgHook } from "../../../utils/makeZeroArgHook";
import getAdvisorsV2 from "../../requests/persons/getAdvisorsV2";
import { advisorsUrl } from "../../requests/urls";
export const advisorsKeyMakerV2 = () => [advisorsUrl("v2")];
const useGetAdvisors = makeZeroArgHook(getAdvisorsV2, advisorsKeyMakerV2);
export default useGetAdvisors;
//# sourceMappingURL=useGetAdvisorsV2.js.map